import React from 'react';

interface ResetFiltersProps {
    fill?: string;
}

export const ResetFilters = ({ fill = '#818998' }: ResetFiltersProps) => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_4595_27699)">
                <g clipPath="url(#clip1_4595_27699)">
                    <path
                        d="M14.6413 8.58333C14.5128 10.1032 13.8685 11.5335 12.8153 12.6368C11.7621 13.7401 10.3633 14.4502 8.85103 14.6493C7.33877 14.8483 5.8039 14.5244 4.50107 13.7311C3.19825 12.9379 2.20578 11.7231 1.68832 10.2882C1.17086 8.85338 1.15952 7.28474 1.65617 5.84255C2.15283 4.40037 3.12763 3.17133 4.41885 2.35934C5.71007 1.54735 7.24009 1.20123 8.75508 1.37839C10.2701 1.55555 11.6789 2.24534 12.748 3.33333H10.6667C10.4898 3.33333 10.3203 3.40357 10.1953 3.5286C10.0702 3.65362 9.99999 3.82319 9.99999 4C9.99999 4.17681 10.0702 4.34638 10.1953 4.4714C10.3203 4.59643 10.4898 4.66667 10.6667 4.66667H13.4287C13.7568 4.66614 14.0714 4.53554 14.3035 4.30348C14.5355 4.07143 14.6661 3.75684 14.6667 3.42867V0.666667C14.6667 0.489856 14.5964 0.320286 14.4714 0.195262C14.3464 0.0702379 14.1768 0 14 0C13.8232 0 13.6536 0.0702379 13.5286 0.195262C13.4036 0.320286 13.3333 0.489856 13.3333 0.666667V2.052C11.9924 0.853819 10.2866 0.142989 8.49163 0.0344742C6.69669 -0.0740408 4.91762 0.426105 3.44215 1.45402C1.96669 2.48194 0.881114 3.97752 0.360994 5.69888C-0.159126 7.42024 -0.0833735 9.26672 0.575999 10.9397C1.23537 12.6127 2.43981 14.0143 3.99451 14.9179C5.54922 15.8215 7.36328 16.1742 9.1433 15.9191C10.9233 15.6639 12.5652 14.8157 13.8035 13.5117C15.0417 12.2077 15.8038 10.5242 15.9667 8.73333C15.9753 8.6405 15.9644 8.54688 15.9349 8.45846C15.9053 8.37003 15.8577 8.28873 15.7949 8.21974C15.7322 8.15075 15.6558 8.09558 15.5706 8.05775C15.4854 8.01992 15.3932 8.00025 15.3 8C15.1373 7.99774 14.9796 8.05628 14.8577 8.16417C14.7359 8.27206 14.6587 8.42154 14.6413 8.58333Z"
                        fill={fill}
                    />
                </g>
            </g>
            <defs>
                <clipPath id="clip0_4595_27699">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
                <clipPath id="clip1_4595_27699">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};
